import service from '@/utils/server';

const modName='/tms/settlementClosing/';
///签收回退
export const submit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/settlementFee/settlementClosing/api/index.js